import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

/** ![fileX2Icon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJNNCAyMmgxNGEyIDIgMCAwIDAgMi0yVjdsLTUtNUg2YTIgMiAwIDAgMC0yIDJ2NCIvPjxwYXRoIGQ9Ik0xNCAydjRhMiAyIDAgMCAwIDIgMmg0TTggMTIuNWwtNSA1TTMgMTIuNWw1IDUiLz48L3N2Zz4=) */
const fileX2Icon = /*#__PURE__*/jsxs(Fragment, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
  }), /*#__PURE__*/jsx("path", {
    d: "M14 2v4a2 2 0 0 0 2 2h4M8 12.5l-5 5M3 12.5l5 5"
  })]
});

export { fileX2Icon };
